module.exports = __webpack_public_path__ + "static/media/sub_logo.01d0f17e.svg";